import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";

const Login = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch("https://astrasighttech.com/api/login.php", {
  method: "POST",
  credentials: "include", // ⭐ REQUIRED
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify(form),
});


      const data = await res.json();

      if (res.ok) {
        // save login state
        localStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem("token", data.token); // if you use tokens

        navigate("/admin/dashboard");
      } else {
        alert(data.error || "Invalid login");
      }
    } catch (err) {
      console.error(err);
      alert("Server unreachable");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Admin Login</h2>

        <input
          type="email"
          name="email"
          placeholder="Email address"
          onChange={handleChange}
          required
        />

        <input
          type="password"
          name="password"
          placeholder="Password"
          onChange={handleChange}
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
};

export default Login;
